import React from "react";
import BoxComponent from "../../components/Base/BoxComponent";
import logo from "./../../assets/images/common/logo.png";
import StackComponent from "../../components/Base/StackComponent";
import ImageComponent from "../../components/Base/ImageComponent";
import LinkComponent from "../../components/Base/LinkComponent";
import ButtonComponent from "../../components/Base/ButtonComponent";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import { useMediaQuery } from "@mui/material";
import { MEDIA } from "../../config/media-limits";
import LargeScreenNavMenus from "./LargeScreenNavMenus";
import SmallScreenMenus from "./SmallScreenMenus";
import { useResponsive } from "../../hooks";

export const NAV_HEIGHT = "80px";

const NAV_LINKS = [
  {
    label: "Home",
    route: "/",
    name: "home",
  },
  {
    label: "About Us",
    route: "/about-us",
    name: "about",
  },
  {
    label: "Services",
    route: "/services",
    name: "services",
  },
  {
    label: "Contact Us",
    route: "/contact-us",
    name: "contact",
  },
];

const Navbar = () => {
  const { isMediumScreen, isSmallScreen, isExtraSmallScreen } = useResponsive();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <BoxComponent
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: NAV_HEIGHT,
          background: `rgba(256,256,256,${isMediumScreen ? 1 : "0.7"})`,
          zIndex: 10000000000000,
          opacity: 1,
          transition: "all 0.4s",
          p: `0px ${isMediumScreen ? "20px" : "120px"} 0 ${
            isMediumScreen ? "20px" : "120px"
          }`,
          "&:hover": {
            background: "white",
            opacity: 1,
          },
        }}
      >
        <StackComponent
          sx={{ height: "100%", width: "100%" }}
          alignItems="center"
        >
          <BoxComponent sx={{ flexGrow: 1 }}>
            <ImageComponent source={logo} width="170px" height="46px" />
          </BoxComponent>
          {isSmallScreen ? (
            <>
              <SmallScreenMenus
                isLoggedIn={isLoggedIn}
                navigate={navigate}
                NAV_LINKS={NAV_LINKS}
              />
            </>
          ) : (
            <>
              <LargeScreenNavMenus
                isLoggedIn={isLoggedIn}
                navigate={navigate}
                NAV_LINKS={NAV_LINKS}
              />
            </>
          )}
        </StackComponent>
      </BoxComponent>
    </React.Fragment>
  );
};

export default Navbar;
